import appApi from '../../../../../../api/app-api';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';
import { StudentScholarshipsStatus } from '../../../../../../api/types/students/student-scholarships/student-scholarship-entity';

export const updateScholarshipStatusOperation = async (
  userId: number,
  scholarshipId: number,
  status: StudentScholarshipsStatus,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);

    const res = await appApi.updateStudentScholarshipStatus(
      userId,
      scholarshipId,
      status,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    toast.success('סטטוס המלגה עודכן בהצלחה');
    setLoading(false);
  } catch (e) {
    toast.error('אירעה שגיאה בעת עדכון סטטוס המלגה');
    setLoading(false);
  }
};
